import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import StockChart from '../../components/chartgraphique/StockChart/index.js';
import { getMarches } from '../../Api/authApi.js.js';
import './graphiquePleinEcran.css';

const GraphiquePleinEcran = () => {
  const { marcheid, leagueid } = useParams();
  const userId = useSelector((state) => state.auth.user.id);
  const [titre, setTitre] = useState(null);

  useEffect(() => {
    getMarches(userId)
      .then(data => {
        const market = data.find(
          (m) => m.marche_id === parseInt(marcheid) && m.league_id === parseInt(leagueid)
        );
        if (market) setTitre(market.titre);
      })
      .catch(() => {});
  }, [userId, marcheid, leagueid]);

  useEffect(() => {
    document.title = titre ? titre : 'Graphique';
  }, [titre]);

  return (
    <div className="graphique-plein-ecran-page">
      <div className="graphique-plein-ecran-card">
        <StockChart marcheId={marcheid} leagueid={leagueid} large />
      </div>
    </div>
  );
};

export default GraphiquePleinEcran;
